import { NavLink } from 'react-router';

import type { NavigationItem } from '@/data/navigation';
import { cn } from '@/lib/utils';

type DesktopNavigationProps = {
  items: readonly NavigationItem[];
};

const DesktopNavigation = ({ items }: DesktopNavigationProps) => (
  <nav className="mx-auto hidden max-w-screen-lg px-4 pb-2 md:flex">
    <ul className="flex w-full items-center justify-center gap-1 text-base text-primary">
      {items.map((item) => (
        <li key={item.label}>
          <NavLink
            to={item.href}
            className={({ isActive }) =>
              cn(
                'block whitespace-nowrap rounded-md border border-transparent px-3 py-2.5 font-medium text-primary underline-offset-4 transition-colors visited:text-primary hover:no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
                isActive
                  ? 'bg-primary/10 font-semibold'
                  : 'border-transparent hover:border-primary/50 hover:bg-primary/5 hover:text-primary hover:no-underline'
              )
            }
          >
            {item.label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);

export default DesktopNavigation;
